import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledCheckBox } from './styles/StyledCheckBox';
import { CONTROLLED_INPUT_INVALID, } from '../../globals';

class CheckBox extends Component {
  render() {
    const { value, inputState, onChange, children, name, required} = this.props;

    return (
      <StyledCheckBox>
        <input id="agreement" type="checkbox" checked={value} aria-checked={value} onChange={e => {onChange(!value, name)}} required={required}/>
        <label htmlFor="agreement" className={(inputState === CONTROLLED_INPUT_INVALID ? 'error' : '')}>
          {children}
        </label>
      </StyledCheckBox>
    );
  }
}

CheckBox.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  inputState: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired, 
  required: PropTypes.bool.isRequired,
};


export default CheckBox;


// <span className={'checkmark' + (inputState === CONTROLLED_INPUT_INVALID ? ' error' : '')}></span>